import { cn } from "../../lib/utils.ts";
import type { ReactNode, Ref } from "react";
import { MobileNavBackButton } from "./mobile-nav-bar.tsx";

export function StickyMobileHeader({
    ref,
    onBack,
    children,
    surface = "white",
    className,
}: {
    ref?: Ref<HTMLDivElement>;
    onBack: () => void;
    children: ReactNode;
    surface?: "white" | "sheet";
    className?: string;
}) {
    return (
        <div
            ref={ref}
            data-safari-chrome-surface
            data-sheet-chrome={surface === "sheet" ? "" : undefined}
            className={cn(
                "sticky top-0 z-40 flex w-full flex-row items-center justify-between border-b border-doberman-black/8 px-6 pt-[calc(env(safe-area-inset-top)+12px)] pb-3 md:hidden",
                surface === "sheet"
                    ? "bg-maltese-white transition-colors duration-200 motion-reduce:transition-none"
                    : "bg-true-white",
                className,
            )}
        >
            <MobileNavBackButton onClick={onBack} />
            {children}
        </div>
    );
}
